import { useMutation } from "@apollo/client/react";
import { UPDATE_TEMPLATE_STAMP } from "../../mutations/invoiceInterpretationTemplates/updateTemplateStamp";
import type { TemplateStampInput } from "../../../models/InvoiceInterpretationInputs";

export const useUpdateTemplateStamp = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: any) => void;
  onError: (error: any) => void;
}) => {
  const [mutation, { loading, error, data }] = useMutation(
    UPDATE_TEMPLATE_STAMP,
    { onCompleted, onError }
  );

  const updateTemplateStamp = async ({
    stamp,
    templateId,
    clientIdentifier,
  }: {
    templateId?: string;
    clientIdentifier?: string;
    stamp: TemplateStampInput;
  }) => {
    return mutation({
      variables: {
        templateId,
        clientIdentifier,
        input: stamp,
      },
    });
  };

  return { updateTemplateStamp, loading, error, data };
};
